/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type PublicScenarioSummaryDisplayType =
  (typeof PublicScenarioSummaryDisplayType)[keyof typeof PublicScenarioSummaryDisplayType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublicScenarioSummaryDisplayType = {
  SLIDER: 'SLIDER',
  TILE: 'TILE',
} as const
